export default __webpack_public_path__ + "static/media/close.cfb4279d.svg";